
import { Vue, Component, Prop } from 'vue-property-decorator'

interface ComponentData {
  icon: {
    name: string
    size: number
  }
  title: string
  description: string
  btnText: string
  isPrivateAccount?: boolean
  html?: boolean
}

@Component({
  name: 'EmptyContentAlternative',
})
export default class EmptyContentAlternative extends Vue {
  @Prop({
    default: () => ({
      icon: {
        name: '$nothingPublishedIcon',
        size: 180,
      },
      title: 'noDiagramTitle',
      description: 'noDiagramText',
      btnText: 'exploreLink',
      privateAccount: false,
    }),
  })
  componentData!: ComponentData
}
